var map = {
	"./i18n/ar.json": [
		70389,
		"src_app_shared_layouts_footer_i18n_ar_json"
	],
	"./i18n/en-CA.json": [
		66191,
		"src_app_shared_layouts_footer_i18n_en-CA_json"
	],
	"./i18n/en-US.json": [
		5634,
		"src_app_shared_layouts_footer_i18n_en-US_json"
	],
	"./i18n/es-MX.json": [
		37768,
		"src_app_shared_layouts_footer_i18n_es-MX_json"
	],
	"./i18n/fr-CA.json": [
		83116,
		"src_app_shared_layouts_footer_i18n_fr-CA_json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 448;
module.exports = webpackAsyncContext;